import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { LocalDeviceDetectorService } from 'dmmp-services'

@Component({
  selector: 'dmmp-mobile-menu',
  templateUrl: './mobile-menu.component.html'
})
export class MobileMenuComponent implements OnInit {

  @Input() menu
  @Input() menuItemColumn
  @Input() universityInfo
  @Output() page = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  @Output() externalLink = new EventEmitter()
  @Input() buttons = []

  mode = 'm'


  constructor(public localDeviceDetector: LocalDeviceDetectorService) { }

  ngOnInit(): void {
  }

}
